export default __webpack_public_path__ + "static/media/sack.bd3cf480.svg";